"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTimelineOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.timeline_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "timeline_outline_svg__transparent_box" },
            React.createElement("path", { className: "timeline_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "timeline_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "timeline_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M25.71 21.29l-1.42 1.42 1.3 1.29H17v-2h-2v2H7v-2H5v2h-.03v2H5v2h2v-2h8v2h2v-2h8.59l-1.3 1.29 1.42 1.42 3.7-3.71-3.7-3.71zM16 19a8 8 0 10-8-8 8 8 0 008 8zm0-14a6 6 0 11-6 6 6 6 0 016-6z" }),
            React.createElement("path", { d: "M18.7 12.29l-1.72-1.7.02-3.58-2-.02-.03 4.42 2.33 2.3 1.4-1.42z" }))));
}
exports.default = SvgTimelineOutline;
//# sourceMappingURL=TimelineOutline.js.map